import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import MeetingStatusBadge from './MeetingStatusBadge';
import { fmtDateTimeInTz } from './meetingsUtils';

export default function MeetingListRow({ meeting }) {
  const navigate = useNavigate();
  return (
    <Card className="rounded-sm cursor-pointer hover:bg-muted/30 transition-colors" onClick={() => navigate(`/meetings/${meeting.id}`)}
      data-testid={`meeting-row-${meeting.id}`}>
      <CardContent className="p-3 flex flex-col items-start sm:flex-row sm:items-center gap-2">
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm truncate">{meeting.company?.name_at_meeting}</p>
          <p className="text-xs text-muted-foreground">
            {fmtDateTimeInTz(meeting.start_at, meeting.tz)} · {meeting.mode === 'PHYSICAL' ? 'In person' : 'Virtual'} · {meeting.organiser_name}
          </p>
        </div>
        <div className="flex items-center gap-2">
          {meeting.is_late && <span className="text-xs text-red-600 font-medium shrink-0" data-testid={`meeting-late-flag-${meeting.id}`}>Late</span>}
          <MeetingStatusBadge status={meeting.status} testId={`meeting-row-status-${meeting.id}`} />
        </div>
      </CardContent>
    </Card>
  );
}
